import { createRouter, createWebHistory } from 'vue-router'; 
import store from '@/store';

const routes = [ 
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Auth/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/Auth/Register.vue')
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('../views/Auth/ResetPassword.vue'),
    beforeEnter: (to, from, next) => { 
      if (!to.query.token || !to.query.email) { 
        next({ name: 'login' }); 
      } else {
        next();  
      }
    }
  },
  {
    path: '/',
    name: 'dashboard',
    component: () => import('../views/Dashboard/Dashboard.vue'),
    redirect: '/dashboardStats',
    children: [
      {
        path: 'dashboardStats',
        name: 'dashboardStats',
        component: () => import('../views/Dashboard/DashboardStats.vue'),
      },
      {
        path: 'offen',
        name: 'offen',
        component: () => import('../views/Dashboard/Offen.vue'),
      },
      {
        path: 'interessiert',
        name: 'interessiert',
        component: () => import('../views/Dashboard/Interessiert.vue'),
      },
      {
        path: 'nichtInteressiert',
        name: 'nichtInteressiert',
        component: () => import('../views/Dashboard/NichtInteressiert.vue'),
      },
      {
        path: 'inBewerbung',
        name: 'inBewerbung',
        component: () => import('../views/Dashboard/InBewerbung.vue'),
      },
      {
        path: 'imGesprach',
        name: 'imGesprach',
        component: () => import('../views/Dashboard/ImGesprach.vue'),
      },
      {
        path: 'absage',
        name: 'absage',
        component: () => import('../views/Dashboard/Absage.vue'),
      },
      {
        path: 'accountDetails',
        name: 'accountDetails',
        component: () => import('../views/Dashboard/AccountDetails.vue'),
      },
      {
        path: 'changePassword',
        name: 'changePassword',
        component: () => import('../views/Dashboard/ChangePassword.vue'),
      },
    ],
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!store.state.auth.token;  
  const isExpired = store.getters['auth/isTokenExpired'];

  if (isExpired) {  
    store.commit('auth/clearAuthData');  
    if (to.name !== 'login' && to.name !== 'register' && to.name !== 'resetPassword') {
      next({ name: 'login' });  
    } else {
      next();  
    } 
  } else if (!isAuthenticated && to.name !== 'login' && to.name !== 'register' && to.name !== 'resetPassword') {  
    next({ name: 'login' });  
  } else if ((to.name === 'login' || to.name === 'register' || to.name === 'resetPassword') && isAuthenticated) {
    next({ name: 'dashboard' });  
  } else {
    next();  
  }
});

export default router
